module.exports = __webpack_public_path__ + "static/img/bg_3.1a99107.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bs/bg_3.jpg
// module id = o69i
// module chunks = 0